import { get } from 'services/api';

export default function fetchExternalData(endpoints) {
  const promises = endpoints.map((endpoint) => {
    return get(endpoint);
  });

  return Promise.all(promises);
}



// WEBPACK FOOTER //
// ./js/utils/fetch-external-data.js